import { render, staticRenderFns } from "./group-add.vue?vue&type=template&id=66be4e95"
import script from "./group-add.vue?vue&type=script&lang=js"
export * from "./group-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports